import { render } from "./NumberInput.vue?vue&type=template&id=6bebda03&scoped=true&ts=true"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"

import _style_0 from "./NumberInput.vue?vue&type=style&index=0&id=6bebda03&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-6bebda03"]])

export default __exports__